import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react'

import App from './App.tsx'
import './index.scss'
import './i18n'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import env from './constants/env.ts'

const setupErrorTracking = () => {
  if ((env.environment === 'tst' || env.environment === 'production') && env.sentryDns) {
    Sentry.init({
      dsn: env.sentryDns,
      integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
      // Performance Monitoring
      tracesSampleRate: 0.01,
      // Session Replay
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      environment: env.environment,
    })
  }
}

setupErrorTracking()

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  disable_session_recording: true, // Start with recording disabled, enable per-org after login
  autocapture: false, // Disable autocapture initially, enable after opt_in
  capture_pageview: false, // Disable pageview initially, enable after opt_in
  opt_out_capturing_by_default: true, // Start with tracking opt-out by default
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogErrorBoundary>
  </PostHogProvider>,
)
